import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareIncidentsNextGenRoute: InvariantJiraRoute = {
	name: 'software-incidents',
	path: '/jira/software/projects/:projectKey/incidents',
};
